<div id="containerone">
    <div id="deleteCircle"><i class="fa  fa-trash-o fa-4x" id="deleteicon" aria-hidden="true"></i></div>
   <h1 id="maintext">Do you want to save it</h1>
    <h2 id="subtext">Are you sure you want to save this ?</h2>
    <div id="btncontainer"> <button id="cancelbtn" (click)="  close()">Cancel</button>
        <button id="deletebtn" (click)="openokdialog()"> Yes,save it!</button></div>
</div>


